module.exports = __webpack_public_path__ + "img/logo.3b12c672.png";